var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.5H0.5C0.224 8.5 0 8.276 0 8C0 7.724 0.224 7.5 0.5 7.5H15.5C15.7765 7.5 16 7.724 16 8C16 8.276 15.7765 8.5 15.5 8.5Z",
    fill: "#1B8C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C7.724 16 7.5 15.7765 7.5 15.5V0.5C7.5 0.224 7.724 0 8 0C8.276 0 8.5 0.224 8.5 0.5V15.5C8.5 15.7765 8.276 16 8 16Z",
    fill: "#1B8C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCategoryIcon);
export default __webpack_public_path__ + "static/media/new-category-icon.a37bde6a58868c55f40aabab94554a1a.svg";
export { ForwardRef as ReactComponent };